// Swiper is imported already
class productDetailSwiper extends HTMLElement {
  constructor() {
    super();

    this.swiperElement = this.querySelector("[data-product-detail-swiper]");

    this.swiperOptions = {
      direction: "horizontal",
    };

    this.init();
  }

  init() {
    window.addEventListener("load", (event) => {
      this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);
    });
    Fancybox.bind("[data-fancybox]", {
      animated: false,
      showClass: false,
    });
  }
}

if (!customElements.get("product-detail-swiper")) {
  customElements.define("product-detail-swiper", productDetailSwiper);
}

class productInfo extends HTMLElement {
  constructor() {
    super();
    this.productForm = this.querySelector("product-form");
    this.productFormQuantity = this.productForm?.querySelector(
      'input[name="quantity"]'
    );
    this.quantityInput = this.querySelector("quantity-input");
    this.quantityInputElement = this.quantityInput?.querySelector(
      'input[name="quantity"]'
    );
    this.quantityInputElement?.addEventListener("change", () => {
      this.handleQuantityInput();
    });

    // trigger the Back in Stock button in the sticky bar to open BIS popup
    this.backInStockButton = this.querySelector("#BIS_trigger");
    if (this.backInStockButton) {
      const addButtonSticky = this.querySelector(
        "[data-add-to-cart-button-sticky]"
      );
      if (addButtonSticky) this.simulateBackInStockButtonClick(addButtonSticky);
    }

    this.algoliaTracking();
  }

  algoliaTracking() {
    /**
     * Try to get the details from local storage for conversion tracking.
     * We're using a try...catch here to handle any possible exceptions resulting
     * from local storage or JSON parsing.
     */
    const trackConversion = () => {
      try {
        // Get any previously stored data.
        const previousClickItemsString = localStorage.getItem(
          "algolia_analytics_clicked_objects"
        );
        // If data was found, send a conversion event for those products.
        // eslint-disable-next-line no-extra-boolean-cast
        if (!!previousClickItemsString) {
          const previousClickItems = JSON.parse(previousClickItemsString);
          previousClickItems.forEach((data) => {
            aa("convertedObjectIDsAfterSearch", data);
          });
        }
      } catch (error) {
        // No need to do anything in this scenario.
      }

      // Try to remove the items from local storage.
      try {
        localStorage.removeItem("algolia_analytics_clicked_objects");
      } catch (error) {
        // No need to do anything in this scenario.
      }
    };

    document.querySelectorAll("[data-add-to-cart-button]").forEach((btn) => {
      btn.removeEventListener("click", trackConversion);
      btn.addEventListener("click", trackConversion);
    });
  }

  /**
   * handleQuantityInput
   * @description Set the quantity from the quantity input web component to the product form web component.
   */
  handleQuantityInput() {
    this.productFormQuantity.value = this.quantityInputElement.value;
  }

  simulateBackInStockButtonClick(addButtonSticky) {
    addButtonSticky.addEventListener("click", (e) => {
      if (addButtonSticky.classList.contains("button--notify-me")) {
        e.preventDefault();
        this.backInStockButton.click();
      }
    });
  }
}

if (!customElements.get("product-info")) {
  customElements.define("product-info", productInfo);
}
